import React, { useState, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';

import usePaymentProvidersConfig from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/hooks/usePaymentProvidersConfig';
import type { PaymentProviderName } from '@/domain/paySettings/helpers';

import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Provider from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/Provider';
import DialogPaymentProviderDetails from '@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/DialogPaymentProviderDetails';

const Providers: React.FC = () => {
  const { formatMessage } = useIntl();
  const paymentProvidersConfig = usePaymentProvidersConfig();
  const [selectedProviderId, setSelectedProviderId] = useState<string | null>(null);

  const providerTitle = useMemo(
    () => (selectedProviderId && paymentProvidersConfig.find((item) => item.id === selectedProviderId)?.title) || '',
    [selectedProviderId, paymentProvidersConfig],
  );

  const closeDetailsDialog = useCallback(() => {
    setSelectedProviderId(null);
  }, [setSelectedProviderId]);

  return (
    <Stack component={Paper} variant="outlined" p={2}>
      <Typography variant="subtitle1" fontWeight={500}>
        {formatMessage({
          id: 'configurations.company.paymentProviders.title',
          defaultMessage: 'Payment Providers',
        })}
      </Typography>
      {paymentProvidersConfig.map(({ title, name, ...rest }) => (
        <Provider
          key={title}
          title={title}
          name={name as PaymentProviderName}
          {...rest}
          setSelectedProviderId={setSelectedProviderId}
        />
      ))}
      {!!selectedProviderId && (
        <DialogPaymentProviderDetails id={selectedProviderId} onClose={closeDetailsDialog} title={providerTitle} />
      )}
    </Stack>
  );
};

export default Providers;
